// The one transient notification surface in the application.
//
// Call sites publish semantic receipts through `done` / `noted` in `notify.ts`; none of
// them chooses a corner, a duration, a colour, a queue size or an accessibility label.
// Keeping those decisions here prevents a module from growing a second toast host or an
// inline strip for a write that has already finished.

import { Toaster } from "@/components/ui/sonner";
import { useT } from "../shell/i18n";
import { TOASTER_CLASSES, TOASTER_THEME } from "./notify";

export function NotificationCenter() {
  const t = useT();

  return (
    <Toaster
      className="z-(--layer-notification)"
      position="bottom-right"
      offset={{
        // Leave room for the shell's bottom action row. Modal priority comes from
        // the shared layer token, not an offset that guesses a dialog's footer height.
        bottom: "calc(var(--size-button) + 2 * var(--spacing-gutter))",
        right: "var(--spacing-gutter)",
      }}
      mobileOffset={{
        bottom: "calc(var(--size-button) + 2 * var(--spacing-gutter))",
        right: "var(--spacing-gutter)",
        left: "var(--spacing-gutter)",
      }}
      theme={TOASTER_THEME}
      closeButton
      visibleToasts={3}
      duration={6000}
      gap={8}
      swipeDirections={["right"]}
      containerAriaLabel={t("notification.region")}
      toastOptions={{
        classNames: TOASTER_CLASSES,
        closeButtonAriaLabel: t("notification.dismiss"),
      }}
      style={{ zIndex: "var(--layer-notification)" }}
    />
  );
}
